export const RESUME_LINK = "https://res.cloudinary.com/j79n5x1d/image/upload/v1785606492/AyushKaushikResume2026_v3ywke.pdf";